<template>
  <div class="column is-12">
    <div class="card">
      <header class="header-card">
        <p>
          {{$t('societes.produitDiversDefaut.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field :label="$t('societes.produitDiversDefaut.tlpe')">
              <b-select v-model="societe.produitIdDefautTlpe" expanded>
                <option :key="null" :value="null"></option>
                <option v-for='produit in listeProduitDiversTlpe(societe.produitIdDefautTlpe)'
                        :key="produit.id"
                        :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('societes.produitDiversDefaut.fraisTechnique')">
              <b-select v-model="societe.produitIdDefautFraisTechnique" expanded>
                <option :key="null" :value="null"></option>
                <option v-for='produit in listeProduitDivers(societe.produitIdDefautFraisTechnique)'
                        :key="produit.id"
                        :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('societes.produitDiversDefaut.pose')">
              <b-select v-model="societe.produitIdDefautPose" expanded>
                <option :key="null" :value="null"></option>
                <option v-for='produit in listeProduitDivers(societe.produitIdDefautPose)'
                        :key="produit.id"
                        :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('societes.produitDiversDefaut.honoraire')">
              <b-select v-model="societe.produitIdHonoraire" expanded>
                <option :key="null" :value="null"></option>
                <option v-for='produit in listeProduitDivers(societe.produitIdHonoraire)'
                        :key="produit.id"
                        :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('societes.produitDiversDefaut.produitAnnulation')">
              <b-select v-model="societe.produitIdAnnulationPaiement" expanded>
                <option :key="null" :value="null"></option>
                <option v-for='produit in listeProduitDivers(societe.produitIdAnnulationPaiement)'
                        :key="produit.id"
                        :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    produitDivers: {
      type: Array,
      required: true,
    },
    societe: {
      type: Object,
      required: true,
    },
  },
  methods: {
    listeProduitDiversTlpe(id) {
      return this.produitDivers.filter((produitDivers) => {
        return produitDivers.produitDivers.tlpe && (produitDivers.actif || produitDivers.id === id);
      });
    },
    listeProduitDivers(id) {
      return this.produitDivers.filter((produitDivers) => {
        return !produitDivers.produitDivers.tlpe
          && (produitDivers.actif || produitDivers.id === id);
      });
    },
  },
};

</script>
